import { render, staticRenderFns } from "./AverageOrderValue.vue?vue&type=template&id=0dc439fc&"
import script from "./AverageOrderValue.vue?vue&type=script&lang=js&"
export * from "./AverageOrderValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports